import { CookieService } from "@src/api/common/CookieService";
import { HttpService } from "@src/api/common/HttpService";
import { UrlService } from "@src/api/common/UrlService";

const IeeApiUrl = CookieService.GetCookie("baseUrl");//'https://crdp-api-test.optum.com'

export const DeviceMigrationSchedulerService = () => {
  const { HttpGet, HttpPost } = HttpService();

  const GetDeviceMigrationWorkspaceScheduler = async (body: any) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${IeeApiUrl}/api/v3/table/device-migration-workspace/scheduler${suffix}`;
    const response = await HttpGet(url);
    return response;
  }
  const UpdateBulkEditSchemaById = async (body: any, showLoader: boolean = false) => {
    const url = `${IeeApiUrl}/api/v3/table/device-migration-workspace/scheduler/bulkedit`;
    const response = await HttpPost(url, body, showLoader);
    return response;
  };
  
  const GetDeviceMigrationWorkspaceSchedulerV4 = async (body: any) => {
    const url = `${IeeApiUrl}/api/v4/table/device-migration-workspace/scheduler`;
    const response = await HttpPost(url, body);
    return response;
  };


  const GetDeviceMigrationBulkEditSchema = async (query?: string, showLoader: boolean = false) => {
    const url = `${IeeApiUrl}/api/v3/table/device-migration-workspace/scheduler/bulkeditschema`;
    const response = await HttpGet(url, showLoader);
    return response;
  };

  return {
    GetDeviceMigrationWorkspaceScheduler,
    GetDeviceMigrationBulkEditSchema,
    UpdateBulkEditSchemaById,
    GetDeviceMigrationWorkspaceSchedulerV4
  };
};
